// import {combineReducers} from "redux-immutable";
import freeStreaming from './freeStreamingReducer';

// if there are more than one reducer in this component, use combineReducer:
/*
const footer = combineReducers({
    NameReducers
});
*/

export default freeStreaming;
